// extracted by mini-css-extract-plugin
module.exports = {"ButtonBase":"ButtonFooterNav_ButtonBase__2PO1T","ButtonPrimary":"ButtonFooterNav_ButtonPrimary__2bPEC","ButtonSizePrimary":"ButtonFooterNav_ButtonSizePrimary__23wvD"};